import { SUMMIT_DAY_1 } from '@@summit/2023/statics/summit-day-1';
import { SUMMIT_DAY_2 } from '@@summit/2023/statics/summit-day-2';
import { SUMMIT_DAY_3 } from '@@summit/2023/statics/summit-day-3';

// 公共常量
// Cookie 当前语言 Key
export const COOKIE_KEY_LANGUAGE = 'summit_2023_language';

// 当前项目的理由 BASE URL
export const ROUTER_BASE_URL = '/summit/2023/index/main';

// 报名结束时间
export const SIGN_UP_END_DATE = '2023-06-12 00:00:00';

// 开幕式时间
export const OPENING_DATE = '2023-06-11 09:00:00';

// 新闻分类 ID
export const JOURNALISM_CATEGORY_ID = 'wXQ8yB';

// 峰会议程
export const SERVICE_TAB_LIST = [
  SUMMIT_DAY_1,
  SUMMIT_DAY_2,
  SUMMIT_DAY_3,
]

//共建单位
export const UNIT_LIST = [
  'https://res.oafimg.cn/-/4f352d6afa50d820/1%E5%8D%8E%E4%B8%BA.png',
  'https://res.oafimg.cn/-/a6db83c0a81903a4/2%20%E9%98%BF%E9%87%8C.png',
  'https://res.oafimg.cn/-/fa043b047a41cca9/3%E8%85%BE%E8%AE%AF.png',
  'https://res.oafimg.cn/-/4fa1b8f0a18c68bf/4%E8%BD%AF%E9%80%9A.png',
  'https://res.oafimg.cn/-/86b4af5904544162/5intel.png',
  'https://res.oafimg.cn/-/aaa2ce5ceedea8c6/6%E4%B8%9C%E8%BD%AF.png',
  'https://res.oafimg.cn/-/4f9d23483fbf9b69/7%E6%B7%B1%E5%BC%80%E9%B8%BF.png',
  'https://res.oafimg.cn/-/adbfdaaff31287d9/8%E8%9A%82%E8%9A%81%E9%9B%86%E5%9B%A2.png',
  'https://res.oafimg.cn/-/98038f1b16da8beb/9%E8%B6%85%E8%81%9A%E5%8F%98.png',
  'https://res.oafimg.cn/-/7287410331f76617/10%E6%B1%9F%E8%8B%8F%E6%B6%A6%E5%92%8C.png',
  'https://res.oafimg.cn/-/1aa589a3baf9d24d/11%E4%B8%87%E9%87%8C%E6%95%B0%E6%8D%AE%E5%BA%93.png',
  // 'https://res.oafimg.cn/-/0af6d9ae1e4dae3a/12%E5%9B%BD%E9%87%91.png',
  'https://res.oafimg.cn/-/8ec3b12eff3efd1f/13%E5%B9%B3%E5%87%AF%E6%98%9F%E8%BE%B0.png',
  'https://res.oafimg.cn/-/9d7e42a637a4878b/14%E8%AF%9A%E8%BF%88%E7%A7%91%E6%8A%80.png',
  'https://res.oafimg.cn/-/b95f33d5fd0d1f6c/15%E9%BA%92%E9%BA%9F%E8%BD%AF%E4%BB%B6.png',
  'https://res.oafimg.cn/-/5f3af926938fd9d6/16%E7%BB%9F%E4%BF%A1.png',
  'https://res.oafimg.cn/-/8f5fc81a29c5930e/17%E5%BD%AD%E4%BA%91%E7%BD%91%E7%BB%9C.png',
  'https://res.oafimg.cn/-/f39c0ef930710662/18%E5%8D%8E%E6%81%92%E7%9B%9B%E4%B8%96.png',
  'https://res.oafimg.cn/-/fa60fc2f983d8499/19%E4%BC%98%E5%8D%9A%E8%AE%AF.png',
  'https://res.oafimg.cn/-/59ffe052740d8038/cetc.png',
  'https://res.oafimg.cn/-/bbbe3e2ae1218b0f/20%E8%BD%AF%E5%AE%89%E7%A7%91%E6%8A%80.png',
  'https://res.oafimg.cn/-/eaa5501749c130b5/22%E5%8D%A1%E5%A5%A5%E6%96%AF.png',
]

// 支持单位
export const SUPPORTING_UNIT_LIST = [
  'https://res.oafimg.cn/-/69153bdaab6512df/23%E6%8B%9B%E5%95%86%E9%93%B6%E8%A1%8C.png',
  'https://res.oafimg.cn/-/58117647bf354ae8/logo.png',
]

// 媒体合作
export const MEDIUM_LIST = [
  {
    title: '开源垂直类',
    content: [
      'https://res.oafimg.cn/-/cb27a9be4224ba12/2.png',
      'https://res.oafimg.cn/-/5f8eac936566fea7/3.png',
      'https://res.oafimg.cn/-/9900e1f0f3415b54/7.png',
      'https://res.oafimg.cn/-/338b611e73c88b38/5.png',
      'https://res.oafimg.cn/-/603e6be3cfa2a75e/9.png',
      'https://res.oafimg.cn/-/143598a1c3e75bf6/11.png',
    ],
  },
  {
    title: '社交新媒体类',
    content: [
      'https://res.oafimg.cn/-/e5f613f398a27db6/1.png',
      'https://res.oafimg.cn/-/48fb905ed485d4a8/4.png',
      'https://res.oafimg.cn/-/8aeeecd5022c7b0c/6.png',
      'https://res.oafimg.cn/-/ad7d72b9f2f5a4eb/8.png',
      'https://res.oafimg.cn/-/2e9bd40594bca030/10.png',

    ],
  },
  {
    title: '主流媒体',
    image: 'https://res.oafimg.cn/-/9fb1feb43229e3f8/output.png',
  },
];

// 峰会嘉宾
export const SUMMIT_GUESTS = [
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
  {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  }, {
    cover: 'https://res.oafimg.cn/-/2261c871b0622648/lj.png',
    name: '雷军',
    title: [
      '中国科学院院士',
      '发展中国家科学院院士',
      '欧洲科学院外籍院士',
      'CCF会士',
      'CCF理事长',
      '北京大学教授',
      'IEEE',
      'fellow',
      'ACM',
      'fellow',
    ],
    intro: '主要从事软件工程和系统软件领域的研究，在构件化软件中间件、开发方法学和工具环境等方面取得了系列成果，发表学术论文200余篇。',
  },
]
